/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const legsFlyComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('LegsFly').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/algu3d.glb',
            objectName: 'FLY_SUPPORT',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('LegsFly').attach(memoEval((self)=>[
            self.$length,
            self.$width,
            self.$height
        ], ($length, $width, $height)=>({
            morphTargetInfluences: {
                Length: {
                    value: $length,
                    scaleOne: 3000,
                    scaleZero: 1400
                },
                Width: {
                    value: $width,
                    scaleOne: 1300,
                    scaleZero: 600
                },
                Height: {
                    value: $height,
                    scaleOne: 780,
                    scaleZero: 740
                }
            }
        })))
];

//# sourceMappingURL=legs-fly.js.map